<template>
	<span :endTime="endTime" :endText="endText">
		{{ content }}
	</span>
</template>

<script>
export default {
	data() {
		return {
			content: '',
			timer: null,
		}
	},
	props: {//接收父组件的数据
		endTime: { type: Number, default: '' },
		endText: { type: String, default: '00:00:00' },
	},
	watch: {//监听时间的变化
		endTime() {
			clearInterval(this.timer)
			this.countdowm(this.endTime)
			this.countdowmInterval(this.endTime)
		}
	},
	mounted() {
		this.countdowm(this.endTime)
		this.countdowmInterval(this.endTime)
	},
	methods: {

		countdowm(timestamp) {
			let self = this;
			let nowTime = new Date();
			let endTime = new Date(timestamp-1000);
			let diff = endTime.getTime() - nowTime.getTime();
			if (diff > 0) {
				let day = Math.floor(diff / (1000 * 60 * 60 * 24));
				let hour = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				let min = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				let sec = Math.floor((diff % (1000 * 60)) / 1000);
				hour = hour < 10 ? "0" + hour : hour;
				min = min < 10 ? "0" + min : min;
				sec = sec < 10 ? "0" + sec : sec;
				let format = '';
				if (day > 0) {
					format = `${day}:${hour}:${min}:${sec}`;
				}
				if (day <= 0 && hour > 0) {
					format = `${hour}:${min}:${sec}`;
				}
				if (day <= 0 && hour <= 0) {
					format = `00:${min}:${sec}`;
				}
				self.content = format;
				self.$emit('countdown_show', true)
			} else {
				clearInterval(self.timer);
				self.content = self.endText;
				self.$emit('countdown_show', false)

			}
		},
		countdowmInterval(timestamp) {
			let self = this;
			self.timer = setInterval(function () {
				self.countdowm(timestamp)
			}, 1000);
		}
	}
}
</script>
<style></style>